module.exports = __webpack_public_path__ + "static/media/Rubik-LightItalic.e59a5453.ttf";